import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paymentMethodType',
  standalone: false
})
export class PaymentTypePipe implements PipeTransform {

  transform(paymentMethod: string, ...args: unknown[]): string {
    if (paymentMethod === 'ACH') {
      return 'ACH';
    } else if (paymentMethod === 'Pending') {
      return 'Pending';
    }
    else {
      return "CC";
    }
  }

}
